import { styled } from "../../../../../styles";

export const PreviewContainer = styled("div", {
  backgroundColor: "$gray-30",
  borderRadius: "8px",
  padding: "32px",

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "24px",
});

export const PreviewControls = styled("div", {
  display: "flex",
  alignItems: "center",
  gap: "12px",
});

/** Roughly a phone screen, so the patient view wraps the way it does in the app. */
export const PhoneFrame = styled("div", {
  position: "relative",
  width: "377px",
  height: "722px",
  overflow: "hidden",
  backgroundColor: "$white",
  border: "1px solid $gray-60",
  borderRadius: "24px",
  boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",

  display: "flex",
  alignItems: "center",
  justifyContent: "center",

  "&[hidden]": { display: "none" },

  variants: {
    device: {
      mobile: {},
      // A desktop browser window: the full width of the preview.
      web: { width: "100%", borderRadius: "12px" },
    },
  },
});

export const PhoneOverlay = styled("div", {
  position: "absolute",
  inset: 0,
  backgroundColor: "$white",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: "16px",
  padding: "24px",
  textAlign: "center",
});

/** The answering screen sizes itself from the window: the iframe gives it a phone's. */
export const PreviewIframe = styled("iframe", {
  width: "375px",
  height: "720px",
  border: "none",

  variants: {
    device: {
      mobile: {},
      web: { width: "100%" },
    },
  },
});

/** The Mobile / Web switch: a pill track with a thumb that slides under the chosen icon. */
export const DeviceTrack = styled("div", {
  position: "relative",
  display: "inline-flex",
  padding: "3px",
  borderRadius: "20px",
  backgroundColor: "$white",
  border: "1px solid var(--colors-builder-button-primary-background)",
});

export const DeviceThumb = styled("span", {
  position: "absolute",
  top: "3px",
  left: "3px",
  width: "40px",
  height: "30px",
  borderRadius: "16px",
  backgroundColor: "var(--colors-button-background)",
  transition: "transform 0.2s ease",

  variants: {
    position: {
      first: { transform: "translateX(0)" },
      second: { transform: "translateX(40px)" },
    },
  },
});

export const DeviceOption = styled("button", {
  position: "relative",
  zIndex: 1,
  width: "40px",
  height: "30px",
  border: "none",
  borderRadius: "16px",
  background: "transparent",
  cursor: "pointer",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "var(--colors-builder-button-secondary-text)",
  transition: "color 0.2s ease",

  "&:focus-visible": {
    outline: "2px solid var(--colors-button-focus-border)",
  },

  variants: {
    selected: {
      true: { color: "var(--colors-button-text)" },
    },
  },
});

export const GraphFrame = styled("div", {
  width: "100%",
  backgroundColor: "$white",
  border: "1px solid $gray-50",
  borderRadius: "8px",
  padding: "24px",

  display: "flex",
  flexDirection: "column",
  gap: "16px",
});

/** The charts size themselves to their parent's height (ResponsiveContainer), like the PROM modal's. */
export const GraphCanvas = styled("div", {
  width: "100%",
  height: "545px",
});
